import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import InputRange from 'react-input-range';
import SimpleReactValidator from 'simple-react-validator';
import 'react-input-range/lib/css/index.css';
import webServices from '../../services/webServices';
import AppConstants from '../../appConstants';
import MultiChipComponent from '../multiChipComponent';
import AlphabetizedAccordionList from '../alphabetizedAccordionList';
import { setUser } from '../../redux/actions/user.actions';
import NoActivePlanPopup from '../../pages/noActivePlanPopup';

const matchPreferences = AppConstants.MATCH_QUEUE_FILTERS;

const MatchValuesModalComponent = (props) => {
  const {
    modalStatus,
    handleClose,
    updateBtnHandler,
    selectedMatchValues,
    matchValuesArr
  } = props;

  const [selectedValuesArr, setSelectedValuesArr] = useState(selectedMatchValues);

  const matchValueChangeHandler = (evt) => {
    const { checked: isChecked, value } = evt.target;

    if (isChecked && !selectedValuesArr.includes(value)) {
      setSelectedValuesArr(prev => ([...prev, value]));
    } else if (!isChecked) {
      setSelectedValuesArr(prev => {
        const newValuesArr = [...prev];
        return newValuesArr.filter(el => el !== value);
      });
    }
  };

  return (
    <Modal
      className="filter-model dashbaord_popup0 doublepopup"
      show={modalStatus}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100">
          <h5 className="modal-title w-100">Select values</h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {matchValuesArr && matchValuesArr.map(el => (
          <div key={el.label} className="form-group custom_wrapper">
            <div className='custom-form-check'>
              <input
                type="checkbox"
                id={`match-value-op-${el.label.toLowerCase().replace(/ /g, '-')}`}
                value={el.label}
                checked={selectedValuesArr.includes(el.label)}
                onChange={matchValueChangeHandler}
              />
              <label htmlFor={`match-value-op-${el.label.toLowerCase().replace(/ /g, '-')}`}>
                {el.label}
              </label>
            </div>


            <div className='dec'>{el.description}</div>
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer className='d-flex flex-justify-between no-wrap'>
        <button type="button" className="btn btn-block themebtn1" onClick={() => updateBtnHandler(selectedValuesArr)}>Update</button>
        <button type="button" className="btn btn-block" onClick={handleClose}>Cancel</button>
      </Modal.Footer>
    </Modal>
  );
}

const MatchQueueFilterComponent = ({ loggedInUser, cancelBtnHandler, filterBtnHandler }) => {
  const dispatch = useDispatch();
  const { current, planDetails } = useSelector((state) => state.user);

  const [, setUpdate] = useState(0);
  const [validator] = useState(new SimpleReactValidator({
    validators: {
      max_five: {
        message: 'Maximum of 5 values allowed.',
        rule: val => val.length < 6,
        required: true
      }
    }
  }));

  const [isMatchValuesPopupVisible, setIsMatchValuesPopupVisible] = useState(false);
  const [rangeValue, setRangeValue] = useState({
    age: {
      min: loggedInUser?.match_preferences?.age?.min ?? 18,
      max: loggedInUser?.match_preferences?.age?.max ?? 75,
      range: [18, 75],
      isEmpty: false
    },
    height: {
      min: loggedInUser?.match_preferences?.height?.min ?? 4,
      max: loggedInUser?.match_preferences?.height?.max ?? 7,
      range: [4, 7],
      isEmpty: false
    },
  });

  const [formMasterData, setFormMasterData] = useState({
    residentStates: [],
    culturalGroups: [],
    culturalSubGroups: [],
    topCulturalSubGroups: [],
    loveGoals: [],
    degree: [],
    occupations: [],
    matchValuesArr: [],
    valuesDetails: [],
    hobbies: [],
    countries: [],
    states: {}
  });
  const [formData, setFormData] = useState({ ...matchPreferences, ...loggedInUser.match_preferences });

  const countriesIsoCodeMapping = useRef({});
  const countriesStatesMapping = useRef({});
  const filterAppliedField = useRef(null);

  const [showNoActivePlanPopup, setShowNoActivePlanPopup] = useState(false);
  const handleCloseNoActivePlanPopup = () => setShowNoActivePlanPopup(false);

  const getCleanedFormData = () => ({
    ...formData,
    origin_countries: formData.origin_countries,
    origin_states: formData.origin_states,
    residence_states: formData.residence_states,
    cultural_groups: formData.cultural_groups,
    cultural_sub_groups: formData.cultural_sub_groups,
    occupations: formData.occupations,
    love_goals: formData.love_goals,
    hobbies: formData.hobbies,
    match_values: formData.match_values,
    min_education_level: formData.min_education_level,
    age: { min: rangeValue.age.min, max: rangeValue.age.max },
    height: { min: rangeValue.height.min, max: rangeValue.height.max },
    smoking_status: formData.smoking_status,
    drinking_status: formData.drinking_status,
    filter_applied_field: filterAppliedField.current
  });

  const fetchMasterData = async () => {
    const cleanedData = getCleanedFormData();
    const response = await webServices.getMatchQueueFilterMasterData(cleanedData);
    if (response?.success === true) {
      // Set Age Range Filter
      const { min: minAge, max: maxAge } = response?.data.minMaxAges;
      if (minAge && maxAge) {
        const ageRangeArr = [(minAge < 18 ? 18 : minAge), maxAge];

        const minMaxAgeRangeArr = current.gender === 'MAN'
          ? [+current.age - 12, +current.age + 6]
          : [+current.age - 6, +current.age + 12]

        minMaxAgeRangeArr[0] = loggedInUser?.match_preferences?.age?.min ?? minMaxAgeRangeArr[0];
        minMaxAgeRangeArr[1] = loggedInUser?.match_preferences?.age?.max ?? minMaxAgeRangeArr[1];
        minMaxAgeRangeArr[0] = minMaxAgeRangeArr[0] < 18 ? 18 : minMaxAgeRangeArr[0];

        setRangeValue(prev => ({
          ...prev,
          age: { ...prev.age, min: minMaxAgeRangeArr[0], max: minMaxAgeRangeArr[1], range: ageRangeArr, isEmpty: false },
        }));
      } else {
        setRangeValue(prev => ({
          ...prev,
          age: { ...prev.age, isEmpty: true },
        }));
      }


      const countriesStatesMappingObj = response?.data.originStates.reduce((accumulator, el) => {
        if (accumulator[el.country] === undefined) {
          accumulator[el.country] = [];
        }

        accumulator[el.country].push(el.state);
        return accumulator;
      }, {});
      countriesStatesMapping.current = countriesStatesMappingObj;

      const countries = [... new Set(response?.data.originCountries.map(el => el.country))];
      const countriesIsoCodeMappingObj = response?.data.originCountries.reduce((accumulator, el) => {
        accumulator[el.country] = el.countryIsoCode;
        return accumulator;
      }, []);
      countriesIsoCodeMapping.current = countriesIsoCodeMappingObj;

      // Set states of already selected countries
      const states = {};
      (formData.origin_countries ?? []).forEach(country => {
        states[country] = countriesStatesMapping.current[country];
      });

      setFormMasterData(prev => ({
        ...prev,
        residentStates: response?.data.residenceStates,
        culturalGroups: response.data.culturalGroups,
        culturalSubGroups: response.data.culturalSubGroups,
        topCulturalSubGroups: response.data.topCulturalSubGroups,
        loveGoals: response.data.loveGoals,
        degree: response.data.educationLevel,
        occupations: response.data.occupations,
        matchValuesArr: response.data.valuesDetails,
        valuesDetails: response.data.valuesDetails.map(el => el.label),
        hobbies: response.data.hobbies,
        countries,
        states
      }));
    }
  };

  useEffect(() => fetchMasterData(), []);

  const setSelectVal = (fieldName, val) => {
    filterAppliedField.current = fieldName;
    setFormData(prev => ({ ...prev, [fieldName]: val ?? [] }))
  };

  const setRangeVal = (fieldName, val) => {
    filterAppliedField.current = fieldName;
    setRangeValue(prev => ({ ...prev, [fieldName]: { ...prev[fieldName], min: val.min, max: val.max } }));
    // fetchMasterData();
  };

  const setOriginStatesSelectVal = (fieldName, val) => {
    filterAppliedField.current = 'origin_states';

    const country = fieldName.split('-')[1];
    setFormData(prev => {
      const newData = { ...prev };
      newData.origin_states[country] = val;
      return newData;
    });
  };

  const originCountryChangeHandler = async (_, countries) => {
    filterAppliedField.current = 'origin_countries';

    const states = {};
    countries.forEach(country => {
      states[country] = countriesStatesMapping.current[country];
    });
    setFormMasterData(prev => ({ ...prev, states }));

    setFormData(prev => {
      const newData = { ...prev };

      const newOriginStates = {};
      const originStates = newData.origin_states ?? {};

      // eslint-disable-next-line no-restricted-syntax
      for (const country of countries) {
        if (originStates[country]) {
          newOriginStates[country] = originStates[country];
        }
      }

      newData.origin_states = newOriginStates;

      newData.origin_countries = countries;

      return newData;
    });
  };

  const submitFormHandler = () => {
    // if (loggedInUser?.isPlanExpired === true) {
    //   setShowNoActivePlanPopup(true);
    //   return;
    // }

    if (validator.allValid()) {
      const cleanedData = getCleanedFormData();

      dispatch(setUser({ ...loggedInUser, match_preferences: cleanedData }));

      filterBtnHandler(cleanedData, true);
    } else {
      validator.showMessages();
      setUpdate(n => n + 1); // force re-render
    }
  };

  const clearBtnHandler = () => {
    // if (loggedInUser?.isPlanExpired === true) {
    //   setShowNoActivePlanPopup(true);
    //   return;
    // }

    dispatch(setUser({ ...loggedInUser, match_preferences: matchPreferences }));

    setFormData(matchPreferences);

    filterBtnHandler(matchPreferences, true);
  };

  const toggleMatchValuesPopupVisible = visibility => setIsMatchValuesPopupVisible(visibility);

  const matchValuesModalUpdateBtnHandler = (selectedArr) => {
    toggleMatchValuesPopupVisible(false);
    setFormData(prevData => ({ ...prevData, match_values: selectedArr }));
  }

  return (
    <>
      <div className='filterPopupMatch'>
        <header>
          <button type="button" className="closebtn" onClick={() => cancelBtnHandler()}>
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Close</span>
          </button>
          <h5>My search criteria</h5>
          <p>Note: Making your criteria too specific will limit available matches</p>
        </header>

        <main className='filpterMain'>
          {/* Age Range */}
          {!rangeValue.age.isEmpty && (
            <div className='form-group'>
              <div className='head mb-4'>
                <label htmlFor='_'>Preferred match age range</label>{/* FREE MODE: PREMIUM badge hidden — <span>PREMIUM</span> */}
              </div>
              <div className="content">
                <InputRange
                  allowSameValues
                  maxValue={rangeValue.age.range[1]}
                  minValue={rangeValue.age.range[0]}
                  step={1}
                  value={rangeValue.age}
                  formatLabel={value => value}
                  onChange={val => setRangeVal('age', val)}
                />
              </div>
            </div>
          )}

          {/* Residence States */}
          {formMasterData.residentStates.length > 0 && (
            <MultiChipComponent
              key="residence_states"
              label="Preferred match residence states"
              fieldName="residence_states"
              values={formMasterData.residentStates}
              defaultSelected={formData.residence_states || []}
              onChange={setSelectVal}
              showSelectedValues
            />
          )}

          {/* Origin Countries */}
          {formMasterData.countries.length > 0 && (
            <MultiChipComponent
              key="origin_countries"
              label="Preferred match origin countries"
              fieldName="origin_countries"
              values={formMasterData.countries}
              defaultSelected={formData.origin_countries || []}
              onChange={originCountryChangeHandler}
              showSelectedValues
            />
          )}

          {/* Origin States */}
          {Object.keys(formMasterData.states || {}).length > 0 && (
            <div className='form-group'>
              <div className='head'>
                <label htmlFor='_'>Preferred match origin states</label>{/* FREE MODE: PREMIUM badge hidden — <span>PREMIUM</span> */}
              </div>
              <div className='content 2'>
                {Object.keys(formMasterData.states).map(country => (
                  <MultiChipComponent
                    key={`origin_states_${country}`}
                    label={`States of ${country}`}
                    secondaryLabel
                    fieldName={`origin_states-${country}`}
                    values={formMasterData.states[country]}
                    defaultSelected={formData.origin_states[country] || []}
                    onChange={setOriginStatesSelectVal}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Cultural Groups */}
          {formMasterData.culturalGroups.length > 0 && (
            <MultiChipComponent
              key="cultural_groups"
              label="Preferred match cultural groups"
              fieldName="cultural_groups"
              values={formMasterData.culturalGroups}
              defaultSelected={formData.cultural_groups || []}
              onChange={setSelectVal}
              singleSelect
            />
          )}

          {/* Cultural Sub Groups */}
          {formMasterData.culturalSubGroups.length > 0 && (
            <div className='form-group'>
              <div className='head'>
                <label htmlFor='_'>Preferred match cultural sub-groups</label>{/* FREE MODE: PREMIUM badge hidden — <span>PREMIUM</span> */}
              </div>
              <div className='body'>
                <AlphabetizedAccordionList
                  fieldName='cultural_sub_groups'
                  options={formMasterData.culturalSubGroups || []}
                  defaultSelected={formData.cultural_sub_groups || []}
                  onChange={setSelectVal}
                  mostUsedOptions={formMasterData.topCulturalSubGroups}
                />
              </div>
            </div>
          )}

          {/* Height Range */}
          {!rangeValue.height.isEmpty > 0 && (
            <div className='form-group'>
              <div className='head mb-4'>
                <label htmlFor='_'>Preferred match height range</label>{/* FREE MODE: PREMIUM badge hidden — <span>PREMIUM</span> */}
              </div>
              <div className="content">
                <InputRange
                  allowSameValues
                  maxValue={rangeValue.height.range[1]}
                  minValue={rangeValue.height.range[0]}
                  step={0.1}
                  value={rangeValue.height}
                  formatLabel={value => value.toFixed(1)}
                  onChange={val => setRangeVal('height', val)}
                />
              </div>
            </div>
          )}

          {/* Love Goals */}
          {formMasterData.loveGoals.length > 0 && (
            <MultiChipComponent
              key="love_goals"
              label="Preferred match love goals"
              fieldName="love_goals"
              values={formMasterData.loveGoals}
              defaultSelected={formData.love_goals || []}
              onChange={setSelectVal}
            />
          )}

          {/* Education Level */}
          {formMasterData.degree.length > 0 && (
            <MultiChipComponent
              singleSelect
              key="min_education_level"
              label="Preferred minimum education level"
              fieldName="min_education_level"
              values={formMasterData.degree}
              defaultSelected={formData.min_education_level ? [formData.min_education_level] : []}
              onChange={(fieldName, val) => setFormData(prev => ({
                ...prev,
                min_education_level: val[0] ?? null
              }))}
            />
          )}

          {/* Occupations */}
          {formMasterData.occupations.length > 0 && (
            <div className='form-group'>
              <div className='head'>
                <label htmlFor='_'>Preferred match occupations</label>{/* FREE MODE: PREMIUM badge hidden — <span>PREMIUM</span> */}
              </div>
              <div className=''>
                <AlphabetizedAccordionList
                  fieldName='occupations'
                  options={formMasterData.occupations || []}
                  defaultSelected={formData.occupations || []}
                  onChange={setSelectVal}
                />
              </div>
            </div>
          )}

          {/* Match Values */}
          {formMasterData.valuesDetails.length > 0 && (
            <MultiChipComponent
              key="match_values"
              label="Preferred match values"
              fieldName="match_values"
              values={formMasterData.valuesDetails}
              defaultSelected={formData.match_values || []}
              onChange={setSelectVal}
              appendDataFn={() => (<button type='button' className='btn btn-default ml-1 learn-more-cre' onClick={() => toggleMatchValuesPopupVisible(true)}>
                Learn More <i className="fa fa-angle-right" />
              </button>)}
            />
          )}

          {/* Smoking Level */}
          <MultiChipComponent
            singleSelect
            key="smoking_status"
            label="Preferred match level of smoking"
            fieldName="smoking_status"
            values={AppConstants.SMOKING_LEVEL_ARR}
            defaultSelected={formData.smoking_status ? [formData.smoking_status] : []}
            onChange={(fieldName, val) => setFormData(prev => ({
              ...prev,
              smoking_status: val[0] ?? null
            }))}
          />

          {/* Drinking Level */}
          <MultiChipComponent
            singleSelect
            key="drinking_status"
            label="Preferred match level of drinking"
            fieldName="drinking_status"
            values={AppConstants.DRINKING_LEVEL_ARR}
            defaultSelected={formData.drinking_status ? [formData.drinking_status] : []}
            onChange={(fieldName, val) => setFormData(prev => ({
              ...prev,
              drinking_status: val[0] ?? null
            }))}
          />

          {/* Hobbies */}
          {formMasterData.hobbies.length > 0 && (
            <MultiChipComponent
              key="hobbies"
              label="Preferred match hobbies"
              fieldName="hobbies"
              values={formMasterData.hobbies}
              defaultSelected={formData.hobbies || []}
              onChange={setSelectVal}
            />
          )}
        </main>

        <footer className='filterFooter'>
          <button type='button' className='btn btn-theme' onClick={submitFormHandler}>Find Matches</button>
          <button type='button' className='btn btn-theme1' onClick={clearBtnHandler}>Clear Filters</button>
        </footer>
      </div>

      {isMatchValuesPopupVisible && (<MatchValuesModalComponent
        modalStatus={isMatchValuesPopupVisible}
        handleClose={() => toggleMatchValuesPopupVisible(false)}
        updateBtnHandler={matchValuesModalUpdateBtnHandler}
        matchValuesArr={formMasterData.matchValuesArr}
        selectedMatchValues={formData.match_values || []}
      />)}

      <NoActivePlanPopup
        modalStatus={showNoActivePlanPopup}
        handleClose={handleCloseNoActivePlanPopup}
        currentPlan={planDetails}
      />
    </>
  );
};

export default MatchQueueFilterComponent;
